import React, { useEffect, useState } from 'react';
import styled from 'astroturf/react';
import routes from 'js/core_pre_webpack/routes';
import { Modal, ModalContent } from 'js/design_system/Modal';
import { Button } from 'js/design_system/Button';
import { Body } from 'js/design_system/Body';
import { Icon } from 'js/design_system/Icon';
import { trackClick } from 'js/utils/trackClick';
import {
  recordShow,
  recordDismissal,
  recordClickthrough,
} from 'js/utils/dismissibles';
import _ContentContainer from "ImpactHubModal-ContentContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/modals/ImpactHubModal.tsx?styleId=ContentContainer";
import _HeaderSection from "ImpactHubModal-HeaderSection.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/modals/ImpactHubModal.tsx?styleId=HeaderSection";
import _HeaderText from "ImpactHubModal-HeaderText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/modals/ImpactHubModal.tsx?styleId=HeaderText";
import _FeaturesSection from "ImpactHubModal-FeaturesSection.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/modals/ImpactHubModal.tsx?styleId=FeaturesSection";
import _FeatureItem from "ImpactHubModal-FeatureItem.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/modals/ImpactHubModal.tsx?styleId=FeatureItem";
import _FeatureIcon from "ImpactHubModal-FeatureIcon.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/modals/ImpactHubModal.tsx?styleId=FeatureIcon";
import _FeatureLabel from "ImpactHubModal-FeatureLabel.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/modals/ImpactHubModal.tsx?styleId=FeatureLabel";
import _CTASection from "ImpactHubModal-CTASection.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/modals/ImpactHubModal.tsx?styleId=CTASection";
import _CloseButton from "ImpactHubModal-CloseButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/modals/ImpactHubModal.tsx?styleId=CloseButton";
import _StyledHeading from "ImpactHubModal-StyledHeading.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/modals/ImpactHubModal.tsx?styleId=StyledHeading";
import _StyledBody from "ImpactHubModal-StyledBody.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/modals/ImpactHubModal.tsx?styleId=StyledBody";
import _FeatureIconPodcast from "ImpactHubModal-FeatureIconPodcast.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/modals/ImpactHubModal.tsx?styleId=FeatureIconPodcast";
import _FeatureIconFiresideChat from "ImpactHubModal-FeatureIconFiresideChat.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/modals/ImpactHubModal.tsx?styleId=FeatureIconFiresideChat";
import _FeatureIconAnalogy from "ImpactHubModal-FeatureIconAnalogy.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/modals/ImpactHubModal.tsx?styleId=FeatureIconAnalogy";
import _FeatureIconPost from "ImpactHubModal-FeatureIconPost.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/modals/ImpactHubModal.tsx?styleId=FeatureIconPost";
import _FeatureIconVideo from "ImpactHubModal-FeatureIconVideo.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/modals/ImpactHubModal.tsx?styleId=FeatureIconVideo";
import _FeatureIconComic from "ImpactHubModal-FeatureIconComic.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/modals/ImpactHubModal.tsx?styleId=FeatureIconComic";
import _FeatureIconSlide from "ImpactHubModal-FeatureIconSlide.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/modals/ImpactHubModal.tsx?styleId=FeatureIconSlide";
import _StyledButton from "ImpactHubModal-StyledButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/modals/ImpactHubModal.tsx?styleId=StyledButton";


const ContentContainer = /*#__PURE__*/styled("div", null, {
  displayName: "ContentContainer",
  styles: _ContentContainer
});

const HeaderSection = /*#__PURE__*/styled("div", null, {
  displayName: "HeaderSection",
  styles: _HeaderSection
});

const HeaderText = /*#__PURE__*/styled("div", null, {
  displayName: "HeaderText",
  styles: _HeaderText
});

const FeaturesSection = /*#__PURE__*/styled("div", null, {
  displayName: "FeaturesSection",
  styles: _FeaturesSection
});

const FeatureItem = /*#__PURE__*/styled("div", null, {
  displayName: "FeatureItem",
  styles: _FeatureItem
});

const FeatureIcon = /*#__PURE__*/styled("div", null, {
  displayName: "FeatureIcon",
  styles: _FeatureIcon
});

const FeatureLabel = /*#__PURE__*/styled("span", null, {
  displayName: "FeatureLabel",
  styles: _FeatureLabel
});

const CTASection = /*#__PURE__*/styled("div", null, {
  displayName: "CTASection",
  styles: _CTASection
});

const CloseButton = /*#__PURE__*/styled("button", null, {
  displayName: "CloseButton",
  styles: _CloseButton
});

const StyledHeading = /*#__PURE__*/styled("h1", null, {
  displayName: "StyledHeading",
  styles: _StyledHeading
});

const StyledBody = /*#__PURE__*/styled(Body, null, {
  displayName: "StyledBody",
  styles: _StyledBody
});

const FeatureIconPodcast = /*#__PURE__*/styled(FeatureIcon, null, {
  displayName: "FeatureIconPodcast",
  styles: _FeatureIconPodcast
});

const FeatureIconFiresideChat = /*#__PURE__*/styled(FeatureIcon, null, {
  displayName: "FeatureIconFiresideChat",
  styles: _FeatureIconFiresideChat
});

const FeatureIconAnalogy = /*#__PURE__*/styled(FeatureIcon, null, {
  displayName: "FeatureIconAnalogy",
  styles: _FeatureIconAnalogy
});

const FeatureIconPost = /*#__PURE__*/styled(FeatureIcon, null, {
  displayName: "FeatureIconPost",
  styles: _FeatureIconPost
});

const FeatureIconVideo = /*#__PURE__*/styled(FeatureIcon, null, {
  displayName: "FeatureIconVideo",
  styles: _FeatureIconVideo
});

const FeatureIconComic = /*#__PURE__*/styled(FeatureIcon, null, {
  displayName: "FeatureIconComic",
  styles: _FeatureIconComic
});

const FeatureIconSlide = /*#__PURE__*/styled(FeatureIcon, null, {
  displayName: "FeatureIconSlide",
  styles: _FeatureIconSlide
});

const StyledButton = /*#__PURE__*/styled(Button, null, {
  displayName: "StyledButton",
  styles: _StyledButton
});

interface ImpactHubModalProps {
  open?: boolean;
  onClose?: () => void;
}

const DISMISSIBLE_NAME = 'ImpactHubModal';

const ImpactHubModal: React.FC<ImpactHubModalProps> = ({
  open: openProp = true,
  onClose,
}) => {
  const [isOpen, setIsOpen] = useState(openProp);

  useEffect(() => {
    if (openProp) {
      recordShow(DISMISSIBLE_NAME);
    }
  }, [openProp]);

  // Explicitly clean up body overflow when modal closes
  useEffect(() => {
    if (!isOpen) {
      document.body.style.overflow = '';
    }
  }, [isOpen]);

  const handleClose = async () => {
    // Record dismissal
    try {
      await recordDismissal(DISMISSIBLE_NAME);
    } catch (_error) {
      // Silently handle errors - modal should still close
    }

    // Close the modal by updating state
    setIsOpen(false);

    // Call onClose callback if provided
    if (onClose) {
      onClose();
    }
  };

  const handleCTAClick = () => {
    // Track the click
    trackClick({
      source: 'impact_hub_modal_cta',
      extra: { action: 'explore_impact_hub' },
    });

    // Record clickthrough for dismissible
    recordClickthrough(DISMISSIBLE_NAME, { action: 'explore_impact_hub' });

    // Navigate to Impact Hub
    window.location.href = routes.impact_home_url();
  };

  return (
    <Modal open={isOpen} onClose={handleClose} showHeader={false}>
      <ModalContent>
        <CloseButton onClick={handleClose} aria-label="Close">
          <Icon name="close" size={24} />
        </CloseButton>
        <ContentContainer>
          <HeaderSection>
            <HeaderText>
              <StyledHeading>Amplify your research impact</StyledHeading>

              <StyledBody size="md">
                AI transforms your papers into content that spreads
              </StyledBody>
            </HeaderText>

            <FeaturesSection>
              <FeatureItem>
                <FeatureIconPodcast>
                  <Icon name="mic" size={20} />
                </FeatureIconPodcast>
                <FeatureLabel>Podcast</FeatureLabel>
              </FeatureItem>

              <FeatureItem>
                <FeatureIconFiresideChat>
                  <Icon name="adaptive_audio_mic" size={20} />
                </FeatureIconFiresideChat>
                <FeatureLabel>Fireside chat</FeatureLabel>
              </FeatureItem>

              <FeatureItem>
                <FeatureIconAnalogy>
                  <Icon name="lightbulb" size={20} />
                </FeatureIconAnalogy>
                <FeatureLabel>Analogy</FeatureLabel>
              </FeatureItem>

              <FeatureItem>
                <FeatureIconPost>
                  <Icon name="campaign" size={20} />
                </FeatureIconPost>
                <FeatureLabel>Post</FeatureLabel>
              </FeatureItem>

              <FeatureItem>
                <FeatureIconVideo>
                  <Icon name="video_library" size={20} />
                </FeatureIconVideo>
                <FeatureLabel>Video</FeatureLabel>
              </FeatureItem>

              <FeatureItem>
                <FeatureIconComic>
                  <Icon name="comic_bubble" size={20} />
                </FeatureIconComic>
                <FeatureLabel>Comic</FeatureLabel>
              </FeatureItem>

              <FeatureItem>
                <FeatureIconSlide>
                  <Icon name="web_stories" size={20} />
                </FeatureIconSlide>
                <FeatureLabel>Slides</FeatureLabel>
              </FeatureItem>
            </FeaturesSection>
          </HeaderSection>

          <CTASection>
            <StyledButton
              size="lg"
              iconRight="arrow_forward"
              onClick={handleCTAClick}
            >
              Explore Impact Hub
            </StyledButton>
          </CTASection>
        </ContentContainer>
      </ModalContent>
    </Modal>
  );
};

export default ImpactHubModal;
